import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { FullComponent } from './layouts/full/full.component';
import { LoginComponent } from './login/login.component';
import {AppBlankComponent} from "./layouts/blank/blank.component";

export const AppRoutes: Routes = [
    {
        path: '',
        component: AppBlankComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: '/contaduria',
                pathMatch: 'full'
            },
            {
                path: 'productos',
                loadChildren: () => import('./productos/productos.module').then(m => m.ProductosModule)
            },
            {
                path: 'contaduria',
                loadChildren: () => import('./contaduria/contaduria.module').then(m => m.ContaduriaModule)
            },
            {
                path: 'analiticos',
                loadChildren: () => import('./analiticos/analiticos.module').then(m => m.AnaliticosModule)
            },
            {
                path: 'player',
                loadChildren: () => import('./player/player.modules').then(m => m.PlayerModule)
            }
        ]
    },{
        path: 'login',
        component: LoginComponent,
    }
];
